
<script setup lang="ts">

import { useBackButton } from "@app/Components/Utilities";

useBackButton();

</script>

<template>

    <div class="bg-white dark:bg-gray-850 tracking-wider text-sm lg:text-base
                 w-full h-full overflow-y-auto flex flex-col pb-12">

        <div class="flex justify-center items-center my-6">
            <strong class="text-lg font-bold">Oil &amp; Lubricants</strong>
        </div>     

        <div class="flex flex-col w-full gap-3 px-4 lg:px-6">
        
            <h1>
                Checking your car's oil level regularly is crucial for maintaining 
                the health and performance of your vehicle. As a general rule of 
                thumb, it's recommended to 
                <strong>check your oil level at least once a month</strong>, or 
                more frequently if you notice any signs of oil consumption or leaks. 
            </h1>
            
            <p>
                Here's why it's important:
            </p>

            <div class="pl-2 lg:pl-4 flex flex-col w-full gap-3 dark:text-gray-300">
            
                <p>
                    <span class="dark:text-white">Lubrication:</span> Engine oil plays a vital role
                    in lubricating the internal components of your car's engine. It creates a 
                    protective barrier between moving parts, reducing friction and preventing 
                    premature wear and damage.
                </p>

                <p>
                    <span class="dark:text-white">Cooling:</span> Engine oil also helps to 
                    dissipate heat generated during combustion. As the oil circulates through 
                    the engine, it absorbs heat from the moving parts and carries it away, 
                    helping to regulate engine temperature. Insufficient oil levels can lead 
                    to increased friction and heat buildup, potentially causing overheating 
                    and engine damage.
                </p>        

                <p>
                    <span class="dark:text-white">Sealing:</span> Engine oil helps to seal 
                    gaps between piston rings and cylinder walls, preventing combustion gases 
                    from escaping into the crankcase. It also helps to maintain the integrity 
                    of gaskets and seals throughout the engine. Low oil levels or dirty oil 
                    can compromise these seals, leading to oil leaks and loss of 
                    engine efficiency.
                </p>

                <p>
                    <span class="dark:text-white">Performance:</span> Adequate oil levels 
                    and clean oil contribute to optimal engine performance. Dirty or 
                    contaminated oil can impede engine function, reducing power output 
                    and fuel efficiency.
                </p>        

                <p>
                    <span class="dark:text-white">Early Detection of Problems:</span> 
                    Monitoring your oil level allows you to detect potential issues early on. 
                    A sudden drop in oil level may indicate a leak or excessive oil consumption, 
                    which could be signs of underlying problems. Identifying and addressing 
                    these issues promptly can help prevent more significant damage and costly 
                    repairs down the road.
                </p>  

            </div>

        </div>

    </div>   
    
</template>
